import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { BusBulkEnrollService } from 'src/app/buses/_services/bus-bulk-enroll.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-enroll-fix-errors',
  templateUrl: './enroll-fix-errors.component.html',
  styleUrls: ['./enroll-fix-errors.component.scss']
})
export class EnrollFixErrorsComponent {
  destroy$ = new Subject<void>();
  currLang
  current_upload_batch_id = null;
  loading = false;
  columns_errors = []
  validation_errors = []
  get_failed_records_retrieved = false;
  is_processing = false;
  constructor(
    private globalService: GlobalService,
    private translate: TranslateService,
    private errorMsgService: ErrorMsgService,
    private router: Router,
    private busBulkEnrollService: BusBulkEnrollService

  ) {

  }
  ngOnInit(): void {
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
    });
    this.globalService.getBulkBusEnroll().pipe(takeUntil(this.destroy$)).subscribe(res => {
      res?.batch_id ? this.setCurrentUploadBatchId(res?.batch_id) : this.setCurrentUploadBatchId(localStorage.getItem('bulkBusEnrollBatchId'));
    })
    this.globalService.getNotifyViewWithBulkEnrollState().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.is_processing = res == 'enroll-in-progress' ? true : false;
    })
    this.getFailedRecords(this.current_upload_batch_id);
  }

  setCurrentUploadBatchId(id: any) {
    this.current_upload_batch_id = id ? id : null;
  }

  getFailedRecords(batch_id: any) {
    this.loading = true;
    if (batch_id) {
      this.busBulkEnrollService.getFailedRecords({}, {}, { batch_id: this.current_upload_batch_id }).pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.loading = false;
        // Add original_student_id to each error object
        this.validation_errors = (res?.data || []).map(error => ({
          ...error,
          original_student_id: error.student_id
        }));
        this.get_failed_records_retrieved = true;
      }, err => {
        this.loading = false;
        this.errorMsgService.setMessage(err?.error?.message);
      })
    }
  }
  ngOnDestroy(): void {
    this.get_failed_records_retrieved = false;
    this.errorMsgService.setMessage('');
  }
}
